import {
  logoutUser
} from '../../utils';

export function* doUserLogout() {
  yield logoutUser();
}
